import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from "../auth.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  path: any;

  connectedAs;

  private _subscription;

  constructor(
    public authService: AuthService,
    private router: Router
  ) {
    this.connectedAs = authService.connectedAs;
    this._subscription = authService.connectedAsChange.subscribe((value) => {
      this.connectedAs = value;
    });
  }

  ngOnInit() {
    this.path = this.router.url.split('/');
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd)
        this.path = this.router.url.split('/');
    });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts